<template>
  <div class="page-body">
    <div class="container-fluid">
      <div class="edit-profile">
        <div class="row">
          <div class="col-12 col-xl-12">
            <div class="card">
              <div class="card-header">
                <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                  Detalles del Reporte #{{ report.id }}
                </div>
              </div>
              <div class="card-body" style="margin-top: 20px;">
                <form @submit.prevent="closeModal">
                  <div class="flex flex-col md:flex-row gap-4 md:gap-8">
                    <!-- ID Reporte y Fecha -->
                    <div class="flex flex-col gap-4 w-full md:w-[300px]">
                      <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">ID Reporte</label>
                        <input 
                          type="text" 
                          :value="report.id"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          readonly
                        />
                      </div>
                      
                      <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Fecha</label>
                        <input 
                          type="text" 
                          :value="formattedDate(report.created_at)"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          readonly
                        />
                      </div>
                    </div>
                    
                    <!-- Motivo y Propiedad -->
                    <div class="flex flex-col gap-4 w-full md:w-[300px]">
                      <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Motivo</label>
                        <input 
                          type="text" 
                          :value="report.report_reason?.name || 'Desconocido'"
                          class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          readonly
                        />
                      </div>
                      
                      <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Propiedad</label>
                        <div class="self-stretch flex items-center">
                          <a 
                            v-if="report.property?.url"
                            :href="report.property.url" 
                            target="_blank"
                            class="flex-grow px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal no-underline hover:underline cursor-pointer"
                            title="Ver propiedad"
                          >
                            {{ report.property?.name || 'N/A' }}
                          </a>
                          <span 
                            v-else
                            class="flex-grow px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          >
                            {{ report.property?.name || 'N/A' }}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <!-- ID Propiedad -->
                    <div class="flex flex-col gap-4 w-full md:w-[300px]">
                      <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                        <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">ID Propiedad</label>
                        <div class="self-stretch flex items-center">
                          <a 
                            v-if="report.property?.id"
                            :href="`/Propiedades/form/${report.property.id}`" 
                            target="_blank"
                            class="flex-grow px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal no-underline hover:underline cursor-pointer"
                            title="Editar propiedad"
                          >
                            {{ report.property?.id || 'N/A' }}
                          </a>
                          <span 
                            v-else
                            class="flex-grow px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                          >
                            {{ report.property?.id || 'N/A' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Descripción -->
                  <div class="mt-6 w-full flex-col justify-start items-start gap-1.5 inline-flex">
                    <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Descripción</label>
                    <textarea 
                      :value="report.description || 'Sin descripción'"
                      class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                      readonly
                      rows="4"
                    ></textarea>
                  </div>

                  <!-- Información del administrador de la propiedad reportada -->
                  <div v-if="report.reported_agent" class="mt-6">
                    <h3 class="text-lg font-medium mb-3">Administrador de la propiedad reportada</h3>
                    <div class="flex flex-col md:flex-row gap-4 md:gap-8">
                      <div class="flex flex-col gap-4 w-full md:w-[300px]">
                        <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                          <div class="self-stretch flex items-center">
                            <a 
                              :href="`/advisors/advisorform/perfil/${report.reported_agent.id}`" 
                              target="_blank"
                              class="flex-grow px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal no-underline hover:underline cursor-pointer"
                              title="Ver perfil del administrador"
                            >
                              {{ report.reported_agent.name || 'N/A' }}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col gap-4 w-full md:w-[300px]">
                        <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Email</label>
                          <input 
                            type="text" 
                            :value="report.reported_agent.email || 'N/A'"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Información del usuario que reportó (si está disponible) -->
                  <div v-if="report.reporter_user" class="mt-6">
                    <h3 class="text-lg font-medium mb-3">Información de la persona que reportó</h3>
                    <div class="flex flex-col md:flex-row gap-4 md:gap-8">
                      <div class="flex flex-col gap-4 w-full md:w-[300px]">
                        <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Nombre</label>
                          <div class="self-stretch flex items-center">
                            <a 
                              :href="`/advisors/advisorform/perfil/${report.reporter_user.id}`" 
                              target="_blank"
                              class="flex-grow px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal no-underline hover:underline cursor-pointer"
                              title="Ver perfil del usuario"
                            >
                              {{ report.reporter_user.name || 'N/A' }}
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-col gap-4 w-full md:w-[300px]">
                        <div class="w-full h-[72px] flex-col justify-start items-start gap-1.5 inline-flex">
                          <label class="text-neutral-500 text-sm font-medium font-['Poppins'] leading-normal">Email</label>
                          <input 
                            type="text" 
                            :value="report.reporter_user.email || 'N/A'"
                            class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                            readonly
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Botón -->
                  <div class="form-footer flex sm:flex-row mt-8">
                    <button type="button" class="custom-cancel-btn w-full sm:w-auto" @click="closeModal">
                      <span class="custom-cancel-btn-text">Volver a la lista</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'ReadReportComponent',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    
    const isProduction = computed(() => {
      return window.location.hostname.includes('tuin.ai') || 
             window.location.hostname.includes('tuin.com') ||
             !window.location.hostname.includes('qa');
    });

    const isQA = computed(() => {
      return window.location.hostname.includes('qa') ||
             window.location.hostname.includes('robify') ||
             window.location.hostname.includes('127.0.0.1') ||
             window.location.hostname.includes('localhost');
    });

    const propertyLink = (propertyCode) => {
      if (!propertyCode) return '#';
      
      if (isProduction.value) {
        return `https://tuin.ai/propiedades/${propertyCode}`;
      } else if (isQA.value) {
        return `https://qa.tuin.ai/propiedades/${propertyCode}`;
      } else {
        return `https://tuin.ai/propiedades/${propertyCode}`;
      }
    };

    return {
      propertyLink
    };
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    formattedDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString("es-ES", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      }).replace(/a\.\s?m\./gi, "a.m.").replace(/p\.\s?m\./gi, "p.m.");
    },
  },
};
</script>

<style scoped>
.text-link {
  color: #FF4265;
  text-decoration: none;
  font-weight: bold;
}

.text-link:hover {
  color: #e01142;
}

.custom-cancel-btn {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #4B5563;
  border: 1px solid #4B5563;
  color: white;
  cursor: pointer;
  margin-right: 10px;
  transition: all 0.3s ease;
}

.custom-cancel-btn-text {
  color: #FFF;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* Estilos responsivos */
@media (max-width: 767px) {
  .card-body {
    padding: 15px;
  }
  
  .flex-col-mobile {
    flex-direction: column;
  }
  
  .w-full-mobile {
    width: 100% !important;
  }
  
  .space-x-4 {
    margin-left: 0;
    margin-right: 0;
  }
  
  .gap-8 {
    gap: 1rem;
  }
  
  .form-footer {
    flex-direction: column;
    gap: 10px;
  }
  
  .custom-cancel-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}

@media (min-width: 768px) {
  .form-footer {
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>